import { QueryClient } from '@tanstack/react-query';

import { SIX_HOURS_IN_MILLISECONDS } from '@/constants/common';
import { useGetMagazineRelatedMagazinesQuery } from '@/hooks/magazine/magazine.gql.impl';
import { GetMagazineRelatedMagazinesQuery } from '@/types/bff/gql-schema';
import { MagazineListItemDto, RelatedMagazinesVo } from '@/types/magazine';
import dayjs from 'dayjs';

const parseRelatedMagazines = (data?: GetMagazineRelatedMagazinesQuery): Array<RelatedMagazinesVo> => {
  const parseMagazineListItem = (magazine: MagazineListItemDto) => {
    return {
      ...magazine,
      magazinePid: magazine.magazinePid,
      date: `${dayjs(magazine.createdAt).format('YYYY.MM.DD')}`,
    };
  };

  if (data) {
    return data.magazineRelatedMagazines.map((magazine) => {
      return {
        ...parseMagazineListItem(magazine as MagazineListItemDto),
        contentType: magazine.contentType,
        isArticle: magazine.contentType === 'ARTICLE',
      };
    });
  }

  return [];
};

const useGetRelatedFaq = (faqPid: string) => {
  const { data: relatedFaq } = useGetMagazineRelatedMagazinesQuery(
    {
      request: {
        size: 4,
        magazinePid: faqPid,
      },
    },
    {
      select: parseRelatedMagazines,
      staleTime: SIX_HOURS_IN_MILLISECONDS,
      cacheTime: SIX_HOURS_IN_MILLISECONDS,
    }
  );

  return {
    relatedFaq,
  };
};

export default useGetRelatedFaq;

useGetRelatedFaq.getKey = (faqPid: string) => {
  return useGetMagazineRelatedMagazinesQuery.getKey({
    request: {
      size: 4,
      magazinePid: faqPid,
    },
  });
};

useGetRelatedFaq.prefetchQuery = async (queryClient: QueryClient, faqPid: string) => {
  await queryClient.prefetchQuery(
    useGetMagazineRelatedMagazinesQuery.getKey({
      request: {
        size: 4,
        magazinePid: faqPid,
      },
    }),
    useGetMagazineRelatedMagazinesQuery.fetcher({
      request: {
        size: 4,
        magazinePid: faqPid,
      },
    })
  );
};
